import { heroData } from '@/mocks/homeData';

export default function Hero() {
  const { tag, h1, slogan, description, stats, primaryCta, secondaryCta } = heroData;

  return (
    <section
      id="hero"
      className="relative w-full min-h-screen flex items-center pt-[72px] overflow-hidden"
    >
      <div className="absolute inset-0 bg-gradient-to-br from-background-100 via-background-50 to-primary-50/40"></div>

      <div className="relative w-full px-4 md:px-6 py-10 md:py-14">
        <div className="flex flex-col lg:flex-row items-center gap-8 md:gap-12 lg:gap-16 w-full max-w-[1280px] mx-auto">
          <div className="flex-1 w-full flex flex-col gap-5 md:gap-6">
            <span className="inline-flex items-center gap-2 self-start px-3 py-1.5 rounded-full bg-primary-100 text-primary-700 text-xs md:text-sm font-semibold whitespace-nowrap">
              <i className="ri-fire-line text-sm"></i>
              {tag}
            </span>

            <h1 className="text-2xl md:text-3xl lg:text-4xl font-heading text-foreground-950 leading-tight">
              {h1}
            </h1>

            <p className="text-base md:text-lg text-primary-600 font-heading">
              {slogan}
            </p>

            <p className="text-sm md:text-base text-foreground-600 leading-relaxed max-w-[600px]">
              {description}
            </p>

            <div className="flex flex-wrap items-center gap-4 md:gap-6">
              {stats.map((stat) => (
                <div key={stat.label} className="flex items-center gap-2">
                  <span className="text-xl md:text-2xl font-heading text-primary-500">{stat.value}</span>
                  <span className="text-xs md:text-sm text-foreground-500">{stat.label}</span>
                </div>
              ))}
            </div>

            <div className="flex flex-col sm:flex-row items-stretch sm:items-center gap-3 pt-2">
              <a
                href={primaryCta.href}
                className="inline-flex items-center justify-center gap-2 px-6 py-3 bg-primary-500 text-background-50 font-semibold text-sm rounded-md hover:bg-primary-600 transition-colors cursor-pointer whitespace-nowrap"
              >
                <i className="ri-play-circle-line text-lg"></i>
                {primaryCta.label}
              </a>
              <a
                href={secondaryCta.href}
                className="inline-flex items-center justify-center gap-2 px-6 py-3 bg-background-50 border border-background-300 text-foreground-700 font-medium text-sm rounded-md hover:border-primary-300 hover:text-primary-600 transition-colors cursor-pointer whitespace-nowrap"
              >
                <i className="ri-download-2-line text-lg"></i>
                {secondaryCta.label}
              </a>
            </div>
          </div>

          <div className="flex-1 w-full flex justify-center lg:justify-end">
            <div className="relative w-full max-w-[500px] aspect-[4/3] rounded-lg overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Entertainment%20news%20breaking%20studio%20with%20dramatic%20red%20and%20warm%20lighting%20multiple%20screens%20showing%20trending%20topics%20modern%20broadcast%20atmosphere%20cinematic%20composition%20editorial%20photography%20high%20contrast%20with%20deep%20shadows%20no%20text%20clean%20background&width=800&height=600&seq=hero-main&orientation=landscape"
                alt="91吃瓜爆料 — 全网最热娱乐八卦第一站"
                className="w-full h-full object-cover object-top"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/20 to-transparent"></div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}